import type { LogLevel } from "./Logger"

/**
 * Logging options.
 */
export type LoggerOptions = boolean | "all" | LogLevel[]
